// @ts-nocheck 23e71697
import * as introsActionTypes from './introsActionTypes';

export default {
  enable: () => ({ type: introsActionTypes.ENABLE_MOBILE_INTROS }),
  disable: () => ({ type: introsActionTypes.DISABLE_MOBILE_INTROS }),
};
